import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Injector, Input, NgZone, OnDestroy, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DropdownProjectListDto, ManualEntryDto, ProdData, ProductivityBarServiceProxy, ProjectServiceProxy, ProjectTaskServiceProxy, UserTaskDto } from '@shared/service-proxies/service-proxies';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { ProductivityCandle } from '../../models/productivity-candle';
import { ProductivityCandleSection } from '../../models/productivity-candle-section';
import { ActivityService } from '../../services/activity.service';
import { ProductivityBarService } from '../../services/productivity-bar.service';
import { DateTime } from 'luxon';
import { TimesheetUtilityService } from '@app/main/time-sheet-new/services/timesheet-utility.service';
@Component({
    standalone: false,
    selector: "activities-productivity-bar",
    templateUrl: "./productivity-bar.component.html",
    styleUrls: ["./productivity-bar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [ProductivityBarService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductivityBarComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    // Api call subscription
    subscription: Subscription;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    // Inputs
    @Input()
    userId: number;
    @Input()
    tenantId: number;
    @Input()
    passMinute: number;
    @Input()
    startTime: number;
    @Input()
    endTime: number;
    @Input()
    RealTime: string;
    @Output()
    OfflineTimeAdded = new EventEmitter<number>();
    currentTime: Date = new Date();
    currTimeMins: number;
    totMins: number;
    isInMonthOrWeekView: boolean;
    weeklyData: any;
    monthlyData: any;
    currentViewType: string = "day";
    dateToLoad: Date;
    // Outputs
    @Output()
    manualTimeAdded = new EventEmitter<void>();
    // Data
    productivityData: ProductivityCandle[];
    // Manual time
    manualTime: ManualEntryDto[];
    // Bottom timeline
    bucketTimeSlot: number = 1; // time slot in hours
    timelineBuckets: number;
    timelineBucketsArray: number[];
    // Blue line
    timeSegment: number; // segment minutes in one bucket
    timeSegmentsInBucket: number;
    timeSegmentArray: number[];
    isOfflineTimeSubmitted: boolean = false;
    // Session storage variable for application Wise Spent Time
    productivityBarData: any;
    isViewProductive: boolean = true;
    isViewUnProductive: boolean;
    isViewNeutral: boolean;
    isOfflineTimeApproved: boolean;
    taskDetails: any[] = [];
    jobs: any[] = [];
    SelectedTaskCategoryId: any;
    taskMenu: any[] = [];
    constructor(injector: Injector, private zone: NgZone, private _projectServiceProxy: ProjectServiceProxy, private _projectTaskServiceProxy: ProjectTaskServiceProxy, private _productivityBarService: ProductivityBarService, private _activityService: ActivityService, private cdRef: ChangeDetectorRef, private _productivityBarServiceProxy: ProductivityBarServiceProxy,
                private _tas: TimesheetUtilityService
    ) {
        super(injector);
        this.daySelectedSubscription = this._activityService.viewSelected.subscribe((r) => this.onViewSelected(r));
    }
    // Sidebar
    isSidebarOpen: boolean = false;
    sliderValue: number = 50;
    sidebarSliderRangeValues: number[] = [
        1440, // No. of minutes corresponding to 9 am on a 24 hour period ((9 - 0) * 60)
        1440, // No. of minutes corresponding to 8 pm on a 24 hour period ( (20 - 0) * 60 )
    ];
    descriptionOfAbsence: string = "";
    sidebarProjectId: number;
    selectedTaskId: number;
    taskList: UserTaskDto[];
    projectList: DropdownProjectListDto[];
    productivityType: ProductivityCandleSection;
    manualTimeIdToDelete: number;
    selectedDate = new Date();
    private scrollReleaseTimers: number[] = [];
    // Header
    title: string = "Productivity Bar";
    // loader — start true so shimmer shows before parent arrival-time API sets startTime/endTime
    isLoading: boolean = true;
    private barRequestToken: number | null = null;
    private barRequestSequence = 0;
    //floor
    Fproductive: number;
    Funproductive: number;
    FNetural: number;
    // Analytics
    meanProductivePercent: number = 0;
    meanUnproductivePercent: number = 0;
    meanNeutralPercent: number = 0;
    daySelectedSubscription: Subscription;
    prodPercentage: ProdData[] = [];
    chartOptions = {
        legend: {
            display: false,
        },
        elements: {
            point: {
                radius: 0,
            },
        },
        layout: {
            padding: {
                bottom: -128,
                left: -158,
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                    angleLines: {
                        display: false,
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false,
                    },
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                    angleLines: {
                        display: false,
                    },
                    ticks: {
                        beginAtZero: true,
                        display: false,
                    },
                },
            ],
        },
    };
    ngOnInit(): void {
        this.currTimeMins = this.currentTime.getHours() * 60 + this.currentTime.getMinutes();
        this.sidebarSliderRangeValues[1] = this.currTimeMins;
        this.productivityDataPercentage();
    }
    viewProductive() {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
    }
    viewUnProductive() {
        this.isViewProductive = false;
        this.isViewUnProductive = true;
        this.isViewNeutral = false;
    }
    viewNeutral() {
        this.isViewProductive = false;
        this.isViewUnProductive = false;
        this.isViewNeutral = true;
    }
    currTimeTotMins(): number {
        let totMins = this.currTimeMins;
        return totMins;
    }
    ngOnChanges() {
        if (this.hasBarHours()) {
            this.prepareBarTimeline();
        }
    }
    Check(event) {
        this.normalizeSidebarSliderRange();
    }
    maxSideBarRange = 0;
    minSideBarRange = 0;
    get sliderMaxRange(): number {
        return Math.max(this.maxSideBarRange || this.currTimeMins, this.minSideBarRange + 5);
    }
    private normalizeSidebarSliderRange(): void {
        const min = this.minSideBarRange || 0;
        const max = this.sliderMaxRange;
        const sortedRange = [...this.sidebarSliderRangeValues].sort((a, b) => a - b);
        let start = Math.max(min, Math.min(sortedRange[0], max));
        let end = Math.max(min, Math.min(sortedRange[1], max));
        if (end - start < 5) {
            if (end >= max) {
                start = Math.max(min, max - 5);
                end = max;
            }
            else {
                end = Math.min(max, start + 5);
            }
        }
        this.sidebarSliderRangeValues = [start, end];
    }
    PRodSideBar() {
        this.maxSideBarRange = this.sidebarSliderRangeValues[1];
        this.minSideBarRange = this.sidebarSliderRangeValues[0];
        this.currTimeMins = this.currTimeMins < this.maxSideBarRange ? this.maxSideBarRange : this.currTimeMins;
        this.normalizeSidebarSliderRange();
        this.cdRef.detectChanges();
    }
    setCurrMins() {
        this.currTimeMins = 1439;
    }
    setCurrDay(val: boolean) {
        this.TimeAddedForPreviousDay = val;
    }
    private hasBarHours(): boolean {
        return this.startTime !== undefined && this.startTime !== -1 && this.endTime !== undefined && this.endTime !== -1 && this.endTime > this.startTime;
    }
    private prepareBarTimeline(): void {
        this.timeSegment = this.passMinute;
        this.timelineBuckets = (this.endTime - this.startTime) / this.bucketTimeSlot;
        this.timelineBucketsArray = [...Array(this.timelineBuckets).keys()].map((r) => r + this.startTime);
        this.timeSegmentsInBucket = (this.bucketTimeSlot * 60) / this.timeSegment;
        this.timeSegmentArray = [...Array(this.timeSegmentsInBucket * this.timelineBuckets).keys()];
    }
    private onViewSelected(r: { type: string; date: Date }): void {
        if (r.type === "week" || r.type === "month") {
            this.currentViewType = r.type;
            this.isLoading = false;
            this.productivityData = undefined;
            this.weeklyData = undefined;
            this.monthlyData = undefined;
            this.clearAllTimeSegments();
            this.markForCheck();
            return;
        }
        else if (r.type === "day") {
            this.productivityData = undefined;
            this.ngUnsubscribe.next();
            this.selectedDate = r.date;
            this.currentViewType = "day";
            this.isLoading = true;
        }
        this.markForCheck();
    }
    ngAfterViewInit(): void {
        this.productivityData = undefined;
        this.cdRef.detectChanges();
    }
    currentCheckDate: Date = new Date;
    refreshProductivityBar(date?: Date): void {
        if (this.startTime === undefined || this.startTime === -1 || this.endTime === undefined || this.endTime === -1 || this.endTime <= this.startTime) {
            return;
        }
        const normalizedDate = date
            ? new Date(date.getFullYear(), date.getMonth(), date.getDate())
            : this.selectedDate;
        const requestToken = ++this.barRequestSequence;
        this.barRequestToken = requestToken;
        this.productivityData = undefined;
        this.isLoading = true;
        this.markForCheck();
        this.setBlankDataForShimmer();
        this.clearAllTimeSegments();
        this.currentCheckDate = normalizedDate;
        this.subscription?.unsubscribe();
        this.ngUnsubscribe.next();
        this.subscription = this._productivityBarService
            .getProductivityBarData(this.userId, this.tenantId, this.timeSegment, this.startTime, this.endTime, normalizedDate)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
            next: (r) => {
                if (this.barRequestToken !== requestToken) {
                    return;
                }
                this.productivityData = r;
                this.manualTime = this._productivityBarService.getManualTime();
                // Populate data in chart after bottom timeline segments are in the DOM (*ngIf="!isLoading").
                setTimeout(() => {
                    this.isLoading = false;
                    this.cdRef.detectChanges();
                    this.populateData(this.productivityData || []);
                    this.markForCheck();
                });
            },
            error: () => {
                if (this.barRequestToken !== requestToken) {
                    return;
                }
                this.isLoading = false;
                this.productivityData = [];
                this.markForCheck();
            },
        });
    }
    setCandleSegmentHeights(): void {
        let candleSegments = document.querySelectorAll(".candle-segment");
        candleSegments.forEach((r) => {
            (r as HTMLElement).style.height = "100%";
        });
    }
    timeStampToSeconds(seconds: string) {
        if (!seconds)
            return 0;
        let arr = seconds.split(":").map((r) => parseInt(r));
        return arr[0] * 3600 + arr[1] * 60 + arr[2];
    }
    async productivityDataPercentage() {
    }
    callApiOneTime = true;
    populateData(productivityData: ProductivityCandle[]): void {
        // Populate candles
        this.timeSegmentArray = this.timeSegmentArray.length > productivityData.length ?
            this.timeSegmentArray.filter(x => x < productivityData.length) : [...Array(productivityData?.length).keys()];
        for (let i = 0; i < productivityData?.length; i++) {
            this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                    const activeSegmentContainer = document.querySelector(`[data-time-segment-index="${i}"]`);
                    const candleSegmentContainer = document.querySelector(`[data-candle-segment-index="${i}"]`);
                    if (productivityData[i]?.isDataAvailable && !productivityData[i]?.privatePercent) {
                        activeSegmentContainer?.classList?.add("active-fill");
                        if ((candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.height = `${productivityData[i].productivePercent}%`;
                        if (productivityData[i].productivePercent == 0 && (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.display = 'none';
                        // unproductive
                        if ((candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.height = `${productivityData[i].unproductivePercent}%`;
                        if (productivityData[i].unproductivePercent == 0 && (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.display = 'none';
                        // neutral
                        if ((candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.height = `${productivityData[i].neutralPercent}%`;
                        if (productivityData[i].neutralPercent == 0 && (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                            (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.display = 'none';
                    }
                    else {
                        activeSegmentContainer?.classList?.remove("active-fill");
                        try {
                            if ((candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement))
                                (candleSegmentContainer?.querySelector("#productive-time-candle") as HTMLElement).style.height = `0`;
                        }
                        catch {
                        }
                        try {
                            if ((candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement))
                                (candleSegmentContainer?.querySelector("#unproductive-time-candle") as HTMLElement).style.height = `0`;
                        }
                        catch {
                        }
                        try {
                            if ((candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement))
                                (candleSegmentContainer?.querySelector("#neutral-time-candle") as HTMLElement).style.height = `0`;
                        }
                        catch {
                        }
                        if (productivityData[i]?.privatePercent <= 0 && productivityData[i]?.isDataAvailable != true) {
                            activeSegmentContainer?.classList?.remove("active-fill-private-time");
                        }
                        else if (productivityData[i]?.privatePercent >= 0 && productivityData[i]?.isDataAvailable == true) {
                            activeSegmentContainer?.classList?.add("active-fill-private-time");
                        }
                    }
                    try {
                        if ((candleSegmentContainer as HTMLElement))
                            (candleSegmentContainer as HTMLElement).style.height = "100%";
                    }
                    catch {
                    }
                }, 7 * i);
            });
        }
        if (!this.RealTime)
            this.calcaulateMeanPaercentage(productivityData, null);
    }
    calcaulateMeanPaercentage(productivityData: ProductivityCandle[] = [], productivityBarData) {
        // Calculate mean percentages
        let temp = new Date();
        if (this.currentCheckDate.getDay() == temp.getDay() && this.currentCheckDate.getMonth() == temp.getMonth() && this.currentCheckDate.getFullYear() == temp.getFullYear()) {
            if (JSON.parse(sessionStorage.getItem("applicationWiseSpentTime")) && !this.RealTime)
                this.productivityBarData = JSON.parse(sessionStorage.getItem("applicationWiseSpentTime"));
            if (productivityBarData && this.RealTime)
                this.productivityBarData = productivityBarData;
            if (this.productivityBarData == null) {
                if (this.callApiOneTime && this.userId != undefined && this.tenantId != undefined) {
                    var date = new Date();
                    this.callApiOneTime = false;
                    this._productivityBarServiceProxy.getUserWiseProductiveUnProductiveAndNuetralData(this.userId, this.tenantId, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), date.getTimezoneOffset()).subscribe((r) => {
                        let reducedTotalArr = r.map((r) => {
                            return [
                                this.timeStampToSeconds(r.productiveTime),
                                this.timeStampToSeconds(r.unProductiveTime),
                                this.timeStampToSeconds(r.nuetralTime),
                            ];
                        });
                        let totalArr = [0, 0, 0];
                        var tot = 0;
                        reducedTotalArr.forEach((r) => {
                            totalArr[0] += r[0];
                            totalArr[1] += r[1];
                            totalArr[2] += r[2];
                            tot += r[0] + r[1] + r[2];
                        });
                        let leftPieChartPercentageArray = [];
                        totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
                        var a = (totalArr[0] / tot) * 1;
                        leftPieChartPercentageArray.push(a);
                        a = (totalArr[1] / tot);
                        leftPieChartPercentageArray.push(a);
                        a = (totalArr[2] / tot);
                        leftPieChartPercentageArray.push(a);
                        if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {
                            return;
                        }
                        leftPieChartPercentageArray = totalArr.map((r) => (r * 100) / totalArr.reduce((a, v) => (a += v), 0) / 100);
                        let val = [
                            new ProdData({
                                id: 0,
                                key: "productive",
                                val: leftPieChartPercentageArray[0] * 100,
                                val2: 0
                            }),
                            new ProdData({
                                id: 1,
                                key: "unproductive",
                                val: leftPieChartPercentageArray[1] * 100,
                                val2: 0
                            }),
                            new ProdData({
                                id: 2,
                                key: "Neutral",
                                val: leftPieChartPercentageArray[2] * 100,
                                val2: 0
                            })
                        ];
                        if (leftPieChartPercentageArray[0] != 0 || leftPieChartPercentageArray[1] != 0 || leftPieChartPercentageArray[2] != 0) {
                            this._productivityBarServiceProxy.calculateProperPercentage(val).subscribe(res => {
                                this.meanProductivePercent = res[0].val;
                                this.meanUnproductivePercent = res[1].val;
                                this.meanNeutralPercent = res[2].val;
                            });
                        }
                        else {
                            this.meanProductivePercent = 0;
                            this.meanUnproductivePercent = 0;
                            this.meanNeutralPercent = 0;
                        }
                        this.markForCheck();
                    });
                }
            }
            else {
                let reducedTotalArr = this.productivityBarData?.map((r) => {
                    return [
                        this.timeStampToSeconds(r.productiveTime),
                        this.timeStampToSeconds(r.unProductiveTime),
                        this.timeStampToSeconds(r.nuetralTime),
                    ];
                });
                let totalArr = [0, 0, 0];
                var tot = 0;
                reducedTotalArr?.forEach((r) => {
                    totalArr[0] += r[0];
                    totalArr[1] += r[1];
                    totalArr[2] += r[2];
                    tot += r[0] + r[1] + r[2];
                });
                let leftPieChartPercentageArray = [];
                totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
                var a = (totalArr[0] / tot) * 1;
                leftPieChartPercentageArray.push(a);
                a = (totalArr[1] / tot);
                leftPieChartPercentageArray.push(a);
                a = (totalArr[2] / tot);
                leftPieChartPercentageArray.push(a);
                if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {
                    return;
                }
                leftPieChartPercentageArray = totalArr.map((r) => (r * 100) / totalArr.reduce((a, v) => (a += v), 0) / 100);
                let val = [
                    new ProdData({
                        id: 0,
                        key: "productive",
                        val: leftPieChartPercentageArray[0] * 100,
                        val2: 0
                    }),
                    new ProdData({
                        id: 1,
                        key: "unproductive",
                        val: leftPieChartPercentageArray[1] * 100,
                        val2: 0
                    }),
                    new ProdData({
                        id: 2,
                        key: "Neutral",
                        val: leftPieChartPercentageArray[2] * 100,
                        val2: 0
                    })
                ];
                if (leftPieChartPercentageArray[0] != 0 || leftPieChartPercentageArray[1] != 0 || leftPieChartPercentageArray[2] != 0) {
                    this._productivityBarServiceProxy.calculateProperPercentage(val).subscribe(res => {
                        this.meanProductivePercent = res[0].val;
                        this.meanUnproductivePercent = res[1].val;
                        this.meanNeutralPercent = res[2].val;
                        this.markForCheck();
                    });
                }
                else {
                    this.meanProductivePercent = 0;
                    this.meanUnproductivePercent = 0;
                    this.meanNeutralPercent = 0;
                }
            }
        }
        else {
            let totalPercentage = parseFloat((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += (v.productivePercent + v.unproductivePercent + v.neutralPercent)), 0)).toFixed(1));
            this.meanProductivePercent = parseFloat(((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.productivePercent), 0) * 100) / totalPercentage).toFixed(1));
            if (isNaN(this.meanProductivePercent)) {
                this.meanProductivePercent = 0;
            }
            this.meanUnproductivePercent = parseFloat(((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.unproductivePercent), 0) * 100) / totalPercentage).toFixed(1));
            if (isNaN(this.meanUnproductivePercent)) {
                this.meanUnproductivePercent = 0;
            }
            this.meanNeutralPercent = parseFloat(((productivityData.filter((r) => r.isDataAvailable).reduce((a, v) => (a += v.neutralPercent), 0) * 100) / totalPercentage).toFixed(1));
            if (isNaN(this.meanNeutralPercent)) {
                this.meanNeutralPercent = 0;
            }
            let val = [
                new ProdData({
                    id: 0,
                    key: "productive",
                    val: this.meanProductivePercent,
                    val2: 0
                }),
                new ProdData({
                    id: 1,
                    key: "unproductive",
                    val: this.meanUnproductivePercent,
                    val2: 0
                }),
                new ProdData({
                    id: 2,
                    key: "Neutral",
                    val: this.meanNeutralPercent,
                    val2: 0
                })
            ];
            if (this.meanProductivePercent != 0 || this.meanUnproductivePercent != 0 || this.meanNeutralPercent != 0) {
                this._productivityBarServiceProxy.calculateProperPercentage(val).subscribe(res => {
                    this.meanProductivePercent = res[0].val;
                    this.meanUnproductivePercent = res[1].val;
                    this.meanNeutralPercent = res[2].val;
                    this.Fproductive = this.meanProductivePercent;
                    this.Funproductive = this.meanUnproductivePercent;
                    this.FNetural = this.meanNeutralPercent;
                    this.markForCheck();
                });
            }
        }
    }
    maxNum = 0;
    openSidebar(): void {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
        this.isSidebarOpen = true;
        this.isOfflineTimeApproved = false;
        this.maxNum = this.sidebarSliderRangeValues[1];
    }
    // method to add productivity data from side panel
    tempStartTime = 9;
    addProductivityData(): void {
        this.isOfflineTimeSubmitted = true;
        if (this.checkIfManualTimeExist()) {
            this.message.error("Manual Time Exists");
            return;
        }
        if (!this.selectedTaskId || !this.sidebarProjectId || !this.productivityType || !this.descriptionOfAbsence) {
            return;
        }
        this.deleteManualTime(false);
        this.tempStartTime = Math.floor(this.sidebarSliderRangeValues[0] / 60);
        this.daySelectedSubscription = this._activityService.getMonthViewSelectedAsObs().subscribe((r) => {
            if (r.type === "day") {
                this.selectedDate = r.date;
                this.currentViewType = "day";
                if (this.selectedTaskId != undefined && this.sidebarProjectId != undefined) {
                    this._productivityBarService
                        .addManualEntry(this.manualTimeIdToDelete, this.sidebarSliderRangeValues, this.descriptionOfAbsence, this.sidebarProjectId, this.selectedTaskId, this.productivityType, this.selectedDate, this.SelectedTaskCategoryId)
                        .subscribe({
                        next: () => {
                            if (!this.TimeAddedForPreviousDay) {
                                this.OfflineTimeAdded.emit(this.tempStartTime);
                            }
                            else {
                                this.manualTimeAdded.emit();
                                this.refreshProductivityBar(this.selectedDate);
                            }
                            this.finishOfflineTimePanel();
                        },
                        error: () => this.finishOfflineTimePanel()
                    });
                }
            }
            this.markForCheck();
        });
    }
    checkIfManualTimeExist() {
        let exist = false;
        let newManualTimeStart = this._productivityBarService.minutesToUTCDateTime(this.sidebarSliderRangeValues[0]);
        let newManualTimeEnd = this._productivityBarService.minutesToUTCDateTime(this.sidebarSliderRangeValues[1]);
        this.manualTime.forEach(manualTime => {
            if (this.manualTimeIdToDelete != manualTime.id && !(manualTime.startTime >= newManualTimeEnd || manualTime.endTime <= newManualTimeStart)) {
                exist = true;
            }
        });
        return exist;
    }
    setBlankDataForShimmer(): void {
        this.productivityData = this.timeSegmentArray.map((r) => {
            return new ProductivityCandle(false);
        });
    }
    clearAllTimeSegments(): void {
        const activeSegmentContainer = document.querySelectorAll(`.time-segment`);
        activeSegmentContainer.forEach((r) => {
            r.classList.remove("active-fill", "active-fill-manual-time", "active-fill-private-time-approved");
        });
    }
    clearMeanPercentage() {
        this.meanProductivePercent = 0;
        this.meanUnproductivePercent = 0;
        this.meanNeutralPercent = 0;
    }
    // monthly view
    // hide bottom blue container and get data for productivity candles
    // remove outline
    async setWeeklyData(date?: Date): Promise<void> {
        const viewDate = date ?? this.selectedDate ?? new Date();
        const weekDayStrArray = this._tas.getWeekStringArrayForTimesheetProject(viewDate, "MMM DD");
        const weekStart = weekDayStrArray[0].toDate;
        const weekEnd = weekDayStrArray[weekDayStrArray.length - 1].toDate;
        const data = await firstValueFrom(this._productivityBarService.getDummyDateForWeeklyView(
            this.userId,
            this.tenantId,
            this.timeSegment,
            DateTime.fromJSDate(weekStart),
            DateTime.fromJSDate(weekEnd),
            false
        ));
        this.weeklyData = {
            labels: data.map((r, i) => i.toString()),
            datasets: [
                {
                    label: "Productive",
                    data: data.map((r) => Math.floor(r.productive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.6,
                    backgroundColor: "#6FCEFB",
                },
                {
                    label: "Unroductive",
                    data: data.map((r) => Math.floor(r.unProdictive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.7,
                    backgroundColor: "#FF7D8B",
                },
                {
                    label: "Neutral",
                    data: data.map((r) => Math.floor(r.neutral)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.6,
                    backgroundColor: "#E4E4E4",
                },
            ],
        };
        this.currentViewType = "week";
    }
    async setMonthlyData(): Promise<void> {
        const data = await firstValueFrom(this._productivityBarService.getDummyDateForMonthlyView());
        this.monthlyData = {
            labels: data.map((r, i) => i.toString()),
            datasets: [
                {
                    label: "Productive",
                    data: data.map((r) => Math.floor(r.productive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#6FCEFB",
                },
                {
                    label: "Unproductive",
                    data: data.map((r) => Math.floor(r.unProdictive)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#FF7D8B",
                },
                {
                    label: "Neutral",
                    data: data.map((r) => Math.floor(r.neutral)),
                    fill: true,
                    borderColor: "rgba(0,0,0,0)",
                    tension: 0.3,
                    backgroundColor: "#E4E4E4",
                },
            ],
        };
        this.currentViewType = "month";
    }
    TimeAddedForPreviousDay = false;
    tempDelete = false;
    deleteManualTime(val: boolean): void {
        this.tempDelete = val;
        this.finishOfflineTimePanel();
        this._productivityBarService.deleteManualTime(this.manualTimeIdToDelete).subscribe(() => {
            if (this.TimeAddedForPreviousDay || this.tempDelete) {
                this.OfflineTimeAdded.emit(this.tempStartTime);
            }
            this.tempDelete = false;
            this.resetSidebar();
            this.markForCheck();
        });
    }
    setDataForEdit(manualEntryDto: ManualEntryDto): void {
        this.manualTimeIdToDelete = manualEntryDto.id;
        this.sidebarSliderRangeValues = [
            this._productivityBarService.jsDateToMinutesInTheDay(this._productivityBarService.getLocalJsDate(manualEntryDto.startTime)),
            this._productivityBarService.jsDateToMinutesInTheDay(this._productivityBarService.getLocalJsDate(manualEntryDto.endTime)),
        ];
        this.descriptionOfAbsence = manualEntryDto.description;
        this.sidebarProjectId = manualEntryDto.projectId;
        this._projectTaskServiceProxy.getJobTaskDetails(this.sidebarProjectId).subscribe((jobDetails: any[]) => {
            this.taskDetails = jobDetails.filter(x => x.jobName);
            this.jobs = [...new Map(this.taskDetails.map(item => { return [item.taskJobId, { id: item.taskJobId, name: item.jobName, projectId: item.projectId, isDeleted: item.isDeleted }]; })).values()].sort((a, b) => a.name.localeCompare(b.name));
            this.SelectedTaskCategoryId = manualEntryDto.taskCategoryId;
            var temp = this.jobs.find((x) => x.id == manualEntryDto.taskCategoryId);
            this.onJobChange(temp);
            this.markForCheck();
        });
        this.loadProjectWiseTasks([this.sidebarProjectId]);
        this.SelectedTaskCategoryId = manualEntryDto.taskCategoryId;
        var temp = this.jobs.find((x) => x.id == manualEntryDto.taskCategoryId);
        this.onJobChange(temp);
        this.productivityType = manualEntryDto.productivityType;
        this.isOfflineTimeApproved = manualEntryDto.isApproved;
        this.selectedTaskId = manualEntryDto.taskId;
        if (this.productivityType == 1) {
            this.isViewProductive = true;
            this.isViewUnProductive = false;
            this.isViewNeutral = false;
        }
        if (this.productivityType == 2) {
            this.isViewProductive = false;
            this.isViewUnProductive = true;
            this.isViewNeutral = false;
        }
        if (this.productivityType == 3) {
            this.isViewProductive = false;
            this.isViewUnProductive = false;
            this.isViewNeutral = true;
        }
        this.cdRef.detectChanges();
    }
    // load all tasks for the filter based on project ids selected
    loadProjectWiseTasks(projectIds: number[]): void {
        this._projectTaskServiceProxy.getProjectWiseUserTaskList(projectIds, undefined, undefined, undefined, false, undefined).subscribe((projectTasks) => {
            this.taskList = projectTasks.reduce((a, v) => {
                return [...a, ...v.userTaskList];
            }, []);
            this.markForCheck();
        });
    }
    loadProjects(): void {
        this._projectServiceProxy.dropdownProjectList(abp.session.userId, abp.session.tenantId, true).subscribe((r) => {
            this.projectList = r;
            this.markForCheck();
        });
    }
    selectProject(project: DropdownProjectListDto): void {
        this.selectedTaskId = undefined;
        this.SelectedTaskCategoryId = undefined;
        if (project) {
            this.getTaskJobDetailsDayView(project.id);
        }
        else {
            this.taskList = undefined;
        }
    }
    resetSidebar(): void {
        this.sidebarProjectId = undefined;
        this.selectedTaskId = undefined;
        this.currentTime = new Date();
        this.currTimeMins = this.currentTime.getHours() * 60 + this.currentTime.getMinutes();
        this.minSideBarRange = 0;
        this.maxSideBarRange = this.currTimeTotMins();
        this.sidebarSliderRangeValues = [0, this.currTimeTotMins()];
        this.productivityType = undefined;
        this.descriptionOfAbsence = undefined;
        this.manualTimeIdToDelete = undefined;
    }
    isDataEmpty() {
        return _.every(this.productivityData, (r) => !r?.isDataAvailable);
    }
    ngOnDestroy(): void {
        this.daySelectedSubscription?.unsubscribe();
        this.productivityData = undefined;
        this.scrollReleaseTimers.forEach((timerId) => window.clearTimeout(timerId));
        this.scrollReleaseTimers = [];
        this.isSidebarOpen = false;
        this.releaseDashboardScroll();
        // This aborts all HTTP requests.
        this.ngUnsubscribe.next();
        // This completes the subject properlly.
        this.ngUnsubscribe.complete();
    }
    // for lengthy long name tooltip hide or show condition
    resetSidePanelErrors() {
        this.isOfflineTimeSubmitted = false;
    }
    closeSidePanel() {
        this.isViewProductive = true;
        this.isViewUnProductive = false;
        this.isViewNeutral = false;
        this.resetSidePanelErrors();
        this.finishOfflineTimePanel();
    }

    onOfflineTimeVisibilityChange(isOpen: boolean): void {
        if (!isOpen) {
            this.finishOfflineTimePanel();
        }
    }

    private finishOfflineTimePanel(): void {
        this.isSidebarOpen = false;
        this.isOfflineTimeApproved = false;
        this.cdRef.markForCheck();
        this.cleanupDrawerArtifacts();
    }

    private cleanupDrawerArtifacts(): void {
        this.scrollReleaseTimers.forEach((timerId) => window.clearTimeout(timerId));
        this.scrollReleaseTimers = [];
        const releaseScrollLock = () => this.releaseDashboardScroll();
        releaseScrollLock();
        // PrimeNG's leave animation is 500ms and only then drops the open class.
        // Release again after that so a closing drawer cannot keep the page locked.
        this.scrollReleaseTimers.push(window.setTimeout(releaseScrollLock, 0));
        this.scrollReleaseTimers.push(window.setTimeout(releaseScrollLock, 600));
    }

    private releaseDashboardScroll(): void {
        if (this.isSidebarOpen) {
            return;
        }

        document.querySelectorAll<HTMLElement>('.p-drawer').forEach((drawer) => {
            if (drawer.getAttribute('data-p-open') === 'true') {
                return;
            }
            drawer.classList.remove('p-drawer-open', 'p-drawer-active', 'p-drawer-visible');
        });

        const anotherDrawerOpen = !!document.querySelector('.p-drawer[data-p-open="true"], .modal.show');
        if (anotherDrawerOpen) {
            return;
        }

        const html = document.documentElement;
        const body = document.body;

        html.classList.remove('p-overflow-hidden');
        body.classList.remove('p-overflow-hidden', 'sidebar-open', 'modal-open', 'modal-close');
        ['overflow', 'overflow-y', 'padding-right', '--p-scrollbar-width', '--scrollbar-width'].forEach((propertyName) => {
            html.style.removeProperty(propertyName);
            body.style.removeProperty(propertyName);
        });

        document.querySelectorAll<HTMLElement>('.app-content-shell').forEach((shell) => {
            shell.style.removeProperty('overflow');
            shell.style.removeProperty('overflow-y');
            if (window.getComputedStyle(shell).overflowY === 'hidden') {
                shell.style.setProperty('overflow-y', 'auto', 'important');
            }
        });

        document.querySelectorAll<HTMLElement>('.p-drawer-mask, .p-sidebar-mask').forEach((mask) => {
            if (mask.querySelector('[data-p-open="true"]')) {
                return;
            }
            mask.style.pointerEvents = 'none';
            mask.style.background = 'transparent';
        });
    }
    getTaskJobDetailsDayView(projectId: number) {
        this._projectTaskServiceProxy.getJobTaskDetails(projectId).subscribe((jobDetails: any[]) => {
            this.taskDetails = jobDetails.filter(x => x.jobName);
            this.jobs = [...new Map(this.taskDetails.map(item => { return [item.taskJobId, { id: item.taskJobId, name: item.jobName, projectId: item.projectId, isDeleted: item.isDeleted }]; })).values()].sort((a, b) => a.name.localeCompare(b.name));
            this.markForCheck();
        });
    }
    onJobChange(selectedJob: any) {
        if (selectedJob !== undefined && selectedJob !== null) {
            this.selectedTaskId = undefined;
            this.taskMenu = this.taskDetails
                .filter((item) => item.taskJobId === selectedJob?.id && (selectedJob.projectId === null || item.projectId === selectedJob.projectId) && !item?.isDeleted)
                .map((item) => { return { id: item.taskId, name: item.masterTaskName, projectId: item.projectId }; }).sort((a, b) => a.name.localeCompare(b.name));
        }
    }
}
